import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../firebase/firebase';
import { useTranslation } from '../../hooks/useTranslation';
import './Auth.css';

const ForgotPassword = ({ onSwitchToLogin, embedded = false }) => {
  const t = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess(t('landingPage.auth.forgotPassword.success'));
      setEmail('');
    } catch (error) {
      console.error('Password reset error:', error);
      switch (error.code) {
        case 'auth/user-not-found':
          setError(t('landingPage.auth.forgotPassword.errors.userNotFound'));
          break;
        case 'auth/invalid-email':
          setError(t('landingPage.auth.forgotPassword.errors.invalidEmail'));
          break;
        case 'auth/too-many-requests':
          setError(t('landingPage.auth.forgotPassword.errors.tooManyRequests'));
          break;
        default:
          setError(t('landingPage.auth.forgotPassword.errors.default'));
      }
    } finally {
      setLoading(false);
    }
  };

  const content = (
    <>
      {!embedded && <h2>{t('landingPage.auth.forgotPassword.title')}</h2>}
      {!embedded && <p className="auth-subtitle">{t('landingPage.auth.forgotPassword.subtitle')}</p>}
      
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}
      
      <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">{t('landingPage.auth.forgotPassword.email')}</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('landingPage.auth.forgotPassword.emailPlaceholder')}
              required
              disabled={loading}
            />
          </div>
          
          <button 
            type="submit" 
            className="auth-button primary"
            disabled={loading}
          >
            {loading ? t('landingPage.auth.forgotPassword.sending') : t('landingPage.auth.forgotPassword.sendResetLink')}
          </button>
        </form>
        
        <div className="auth-links">
          <button 
            type="button" 
            className="link-button"
            onClick={onSwitchToLogin}
            disabled={loading}
          >
            {t('landingPage.auth.forgotPassword.backToSignIn')}
          </button>
        </div>
        
        <div className="auth-info">
          <p>
            <strong>{t('landingPage.auth.forgotPassword.note')}</strong> {t('landingPage.auth.forgotPassword.noteText')}
          </p>
        </div>
    </>
  );

  if (embedded) {
    return content;
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        {content}
      </div>
    </div>
  );
};

export default ForgotPassword; 